import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import * as React from 'react';
import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import { computed } from 'mobx';
import getFilteredDateFormatOptions from '../utils/getFilteredDateFormatOptions';
import selectDateFormatOption from '../data/mutators/selectDateFormatOption';
import strings from 'owa-strings/owa-options-strings';
import { formatDate } from 'owa-datetime-format';
import { format } from 'owa-strings';
var today = new Date();
// Always be in the future, according to Lindsay
var EXAMPLE_DATE = new Date(today.getMonth() >= 8 ? today.getFullYear() + 1 : today.getFullYear(), 8, 1);
var DateFormatSelection = /** @class */ (function (_super) {
    tslib_1.__extends(DateFormatSelection, _super);
    function DateFormatSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectDateFormat = function (item) {
            if (_this.props.onSave) {
                _this.props.onSave(item.key);
            }
            else {
                selectDateFormatOption(item.key);
            }
        };
        return _this;
    }
    DateFormatSelection.prototype.render = function () {
        var savedDateFormat = getUserConfiguration().UserOptions.DateFormat;
        var selectedKey = getRegionalOptions().selectedDateFormat || savedDateFormat;
        if (getFilteredDateFormatOptions().indexOf(selectedKey) === -1) {
            selectedKey =
                getFilteredDateFormatOptions().indexOf(savedDateFormat) === -1
                    ? getFilteredDateFormatOptions()[0]
                    : savedDateFormat;
        }
        var label = this.props.showExampleWithDateFormatLabel
            ? format(strings.option_regional_dateFormat, EXAMPLE_DATE.getFullYear())
            : strings.option_regional_dateFormatWithoutExample;
        return (React.createElement(Dropdown, { label: label, options: this.dateFormatOptions, selectedKey: selectedKey, onChanged: this.onSelectDateFormat }));
    };
    Object.defineProperty(DateFormatSelection.prototype, "dateFormatOptions", {
        get: function () {
            return getFilteredDateFormatOptions().map(function (shortDateFormat) {
                return {
                    text: formatDate(EXAMPLE_DATE, shortDateFormat, false),
                    key: shortDateFormat,
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], DateFormatSelection.prototype, "dateFormatOptions", null);
    DateFormatSelection = tslib_1.__decorate([
        observer
    ], DateFormatSelection);
    return DateFormatSelection;
}(React.Component));
export default DateFormatSelection;
//# sourceMappingURL=DateFormatSelection.js.map